import { formatForDisplay } from "@tanstack/react-hotkeys";

import type { KbdHotkey } from "./Kbd";

/**
 * A shortcut in words rather than glyphs (`"Cmd+K"`, `"ArrowLeft"`), for an
 * accessible name beside a `Kbd`. Resolved for the viewer's platform, like
 * `Kbd`, from the same value.
 */
export function hotkeyText(hotkey: KbdHotkey): string {
  return formatForDisplay(hotkey, { useSymbols: false });
}
